import styled from 'styled-components';
import React, { memo } from 'react';
import { useForm, useField } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { SearchTabs } from '../../ui/SearchTabs';
import {
  FORM_VALUES,
  LEASED_TYPES_NEW_ADD
} from '../../../utils/helpers/constants';
import { TabVariantEnum } from '../../ui/SearchTabs/types';
import useScreenSize from '../../../hooks/useScreenSize';
import { generateDataStat } from '../../../utils/helpers/generateDataStat';
import { useClient } from '../../../hooks/useClient';

export const TabsWrapper = styled.div`
  width: 100%;

  ul {
    width: 100%;
    min-width: auto;
  }
`;

interface DealTypeTabsProps {
  dataStats: { value: string; dataStat: string }[];
}

const DealTypeTabsComponent: React.FC<DealTypeTabsProps> = ({ dataStats }) => {
  const { t } = useTranslation();
  const { input: leasedInput } = useField(FORM_VALUES.leased, {
    subscription: { value: true }
  });
  const { input: paidDailyInput } = useField(FORM_VALUES.paidDaily, {
    subscription: { value: true }
  });
  const { change } = useForm();
  const leased = leasedInput.value as string;
  const paidDaily = paidDailyInput.value as string;
  const { isSmall } = useScreenSize();
  const isClient = useClient();

  const handleTabClick = (value: string) => {
    change(FORM_VALUES.leased, value);

    if (value === 'true' && !paidDaily) {
      change(FORM_VALUES.paidDaily, 'false');
    }
  };

  const tabsTitles = LEASED_TYPES_NEW_ADD.map(type => {
    const tabStat = dataStats.find(stat => stat.value === type.value)?.dataStat;

    return {
      name: type.id,
      label: t(type.name),
      isSelected: type.value === leased,
      stat: generateDataStat(tabStat || '', isSmall, isClient) || '',
      onClick: () => handleTabClick(type.value)
    };
  });

  return (
    <TabsWrapper>
      <SearchTabs
        titles={tabsTitles}
        disabled={false}
        variant={TabVariantEnum.Blue}
        height={54}
      />
    </TabsWrapper>
  );
};

export const DealTypeTabs = memo(DealTypeTabsComponent);
